import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Feed Audit is read-only for every tenant member — auth + tenant are already
 *  enforced by the parent `_authenticated/_tenant` layout, so no extra guard
 *  here. The run-creation routes (`create`, `upload`) add their own
 *  `requireTenantAdmin` guard so only subsidiary/super admins can start a run. */
export const Route = createFileRoute('/_authenticated/_tenant/feed-audit')({
  component: () => <Outlet />,
});
